import { Component, ReactNode } from "react";
import { object } from "prop-types";

interface ReactRouterContextProviderProps {
	router: object;
	children: ReactNode;
}

export class ReactRouterContextProvider extends Component<ReactRouterContextProviderProps> {
	static readonly childContextTypes = {
		router: object.isRequired,
	};

	static readonly propTypes = {
		router: object.isRequired,
		children: object.isRequired,
	};

	getChildContext() {
		return {
			router: this.props.router,
		};
	}

	render() {
		return this.props.children;
	}
}
